import {BookingScheduleRepository, BookingTimeSlotsRepository} from "../../domain/types";
import {BookingAvailabilityRepositoryV2} from "./repository.v2";

export {BookingAvailabilityRepositoryV2} from "./repository.v2";
export type {
  BookingScheduleRepository,
  BookingTimeSlotsRepository,
} from "../../domain/types";

/**
 * Creates the time-slots repository.
 *
 * @example
 * const repository = createBookingTimeSlotsRepository();
 * const slots = await repository.getTimeSlots(query);
 */
export const createBookingTimeSlotsRepository = (): BookingTimeSlotsRepository => {
  return new BookingAvailabilityRepositoryV2();
};

/**
 * Creates the schedule repository (bookable weekdays + blocked-out dates).
 */
export const createBookingScheduleRepository = (): BookingScheduleRepository => {
  return new BookingAvailabilityRepositoryV2();
};
